export interface ResourceHint {
  rel: 'preload' | 'preconnect' | 'prefetch' | 'dns-prefetch';
  href: string;
  as?: 'script' | 'style' | 'image' | 'font' | 'fetch';
  type?: string;
  crossOrigin?: 'anonymous' | 'use-credentials' | '';
}

/**
 * Resource hints emitted for the partners page (preconnect to the API origin
 * so the inquiry form's first POST doesn't pay TLS+DNS cost).
 *
 * Rendered from the partners route shell's `meta` export as plain `link`
 * descriptors — see `app/routes/$locale.partners.tsx`.
 */
export const partnersResourceHints: ResourceHint[] = [
  { rel: 'preconnect', href: import.meta.env.VITE_API_URL || 'https://api.tserentals.com' },
];
